module.exports = __webpack_public_path__ + "static/media/New_User_Template.fb5d0fbb.xlsx";